import { render, staticRenderFns } from "./WalletConnector.vue?vue&type=template&id=01bb0038&"
import script from "./WalletConnector.vue?vue&type=script&lang=js&"
export * from "./WalletConnector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports